var _circle, _circle2, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteWarnCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55.9992,
    cy: 56,
    r: 55.3,
    fill: "white",
    stroke: "#FEDF89"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.4008,
    cy: 56.4001,
    r: 49.6,
    fill: "#FEF0C7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.8008 44.8001H42.8008H74.8008",
    stroke: "#DC6803",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8008 44.8001V40.8001C48.8008 39.7392 49.2222 38.7218 49.9724 37.9717C50.7225 37.2215 51.7399 36.8001 52.8008 36.8001H60.8008C61.8616 36.8001 62.8791 37.2215 63.6292 37.9717C64.3794 38.7218 64.8008 39.7392 64.8008 40.8001V44.8001M70.8008 44.8001V72.8001C70.8008 73.861 70.3794 74.8784 69.6292 75.6285C68.8791 76.3787 67.8616 76.8001 66.8008 76.8001H46.8008C45.7399 76.8001 44.7225 76.3787 43.9724 75.6285C43.2222 74.8784 42.8008 73.861 42.8008 72.8001V44.8001H70.8008Z",
    stroke: "#DC6803",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8008 54.8001V66.8001",
    stroke: "#DC6803",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8008 54.8001V66.8001",
    stroke: "#DC6803",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteWarnCircle);
export default __webpack_public_path__ + "static/media/delete_warn_circle.34b3e0b00aacc9af46cc9b71b49d4a01.svg";
export { ForwardRef as ReactComponent };